import { render, staticRenderFns } from "./ParamTipoCombustivel.vue?vue&type=template&id=56d737f1"
import script from "./ParamTipoCombustivel.vue?vue&type=script&lang=js"
export * from "./ParamTipoCombustivel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports